import React from 'react';
import { BuilderInfoProps } from './types';
import * as BuilderInfoUI from './BuilderInfoUI';
import NamedMeasureInfo from './NamedMeasureInfo';
import NamedFilterInfo from './NamedFilterInfo';
import NamedBucketDefInfo from './NamedBucketDefInfo';
import VirtualEventInfo from './VirtualEventInfo';
import ReportInfo from './ReportInfo';
import NamedCohortInfo from './NamedCohortInfo';
import BasicBucketDefInfo from './BasicBucketDefInfo';
import { UnreachableCaseError } from 'ts-essentials';

export default (props: BuilderInfoProps) => {
  const { kind } = props;

  if (kind === 'namedMeasure') {
    return (
      <BuilderInfoUI.Container $kind={kind}>
        <NamedMeasureInfo {...props} />
      </BuilderInfoUI.Container>
    );
  }

  if (kind === 'namedFilter') {
    return (
      <BuilderInfoUI.Container $kind={kind}>
        <NamedFilterInfo {...props} />
      </BuilderInfoUI.Container>
    );
  }

  if (kind === 'basicBucketDef') {
    return (
      <BuilderInfoUI.Container $kind={kind}>
        <BasicBucketDefInfo {...props} />
      </BuilderInfoUI.Container>
    );
  }

  if (kind === 'namedBucketDef') {
    return (
      <BuilderInfoUI.Container $kind={kind}>
        <NamedBucketDefInfo {...props} />
      </BuilderInfoUI.Container>
    );
  }

  if (kind === 'virtualEvent') {
    return (
      <BuilderInfoUI.Container $kind={kind}>
        <VirtualEventInfo {...props} />
      </BuilderInfoUI.Container>
    );
  }

  if (kind === 'report') {
    return (
      <BuilderInfoUI.Container $kind={kind}>
        <ReportInfo {...props} />
      </BuilderInfoUI.Container>
    );
  }

  if (kind === 'namedCohort') {
    return (
      <BuilderInfoUI.Container $kind={kind}>
        <NamedCohortInfo {...props} />
      </BuilderInfoUI.Container>
    );
  }

  throw new UnreachableCaseError(kind);
};
